import axios from 'axios';
import axiosRetry from 'axios-retry';

// Setup auto retry
axiosRetry(axios, {
  retryDelay: axiosRetry.exponentialDelay,
});

export default axios;
